export const EMAIL_VALIDATOR = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;
export const TICKET_NUMBER_VALIDATOR = /[0-9a-fA-F]{8}[0-9a-fA-F]{4}[0-9a-fA-F]{4}[0-9a-fA-F]{4}[0-9a-fA-F]{12}/;
export const NAME_VALIDATOR = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
export const ONLY_NUMBERS_VALIDATOR = /^[0-9]+$/;
export const PHONE_NUMBER_PATTERN = '(999) 999-9999';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'MMMM Do YYYY, h:mm a';
